import cn from 'classnames';
import React from 'react';
import './question.scss';

const Question = ({
	question,
	answer,
	index,
	activeQuestion,
	handleQuestion
}) => (
	<div
		className={cn('row question', {
			active: index === activeQuestion,
			opacity: activeQuestion !== -1 && index !== activeQuestion
		})}
		onClick={handleQuestion}
	>
		<div className="col-xs-12">
			<div className="question-label middle-xs">
				{question} <div className="arrow" />
			</div>
		</div>
		<div className="col-xs-12">
			<span className="answer">{answer}</span>
		</div>
	</div>
);

export default Question;
